/**
 @author xiaoye
 @date 2020/4/9 2:43 下午
 */
import {
    setToken,
    getToken,
    delToken
} from "./basis";

let login_pageName = 'login';
let homeName = 'rearMain';

export default (selp) => {
    selp.$router.beforeEach((to, from, next) => {
        selp.$refs.topProgress.start();
        next();
    });
    selp.$router.afterEach((to, from) => {
        let token = getToken();
        if (to.name === 'shareScreen') {
            selp.$router.push({
                path: to.fullPath
            });
            return
        }
        if (to.fullPath === '/404') {
            selp.$router.push({
                path: to.fullPath
            });
            return
        }
        if (!token && to.name !== login_pageName && to.name !== 'register' && to.name !== 'forgetpass') {
            // 未登录 / 不是登录页
            selp.$router.push({
                name: login_pageName
            });
        } else if (token && to.name === login_pageName) {
            // 已登录 / 是登录页
            selp.$router.push({
                name: homeName
            });
        }
        document.getElementsByTagName('title')[0].innerHTML = selp.$route.meta.tagName || '';
        setTimeout(() => {
            selp.$refs.topProgress.done();
        }, 300);
        window.scrollTo(0, 0);
    });
};